import { IEntityManagerProps, IEntityManagerStates, IInitialData } from "../../components/entityManager/interfaces";
import { IEntity, IFetchingInfo } from "../../components/infrastructure/models";
import { ICity } from "../city/interfaces";
import { IDamageType } from "../damageType/interfaces";
import { ICenter } from "../center/interfaces";
import { IProvince } from "../province/interfaces";
import { IUser } from "../../account/user/interfaces";
import { IPolicyholderConfirmation } from "../../evaluation/damageCaseEvaluator/policyholderConfirmation";
import { IFilter } from "../../components/infrastructure/filtering";
import { IPolicyEquipmentModel } from "../policyEquipmentModel/interfaces";

export enum enmIssuerTypes {
    Self = 1,
    Cp = 2,
    Paliz = 3
}

export enum enmDamageCaseStatus {
    Create = 0,
    AssignEvaluator = 1,
    Evaluation = 2,
    AssignRepairCenter = 3,
    Repairation = 4,
    Financial = 5,
    Closed = 6,
    Rejected = 7,
    ReceiveDepreciated = 8,
    ReceiveEquipment = 9
}

export enum enmEvaluationStatus {
    DocumentCheck = 0,
    DefectiveDocuments = 1,
    ContactSetting = 2,
    MakingContact = 3,
    DamageEstimation = 4,
    PolicyholderConfirmation = 5,
    PolicyholderRejected = 6,
    EvaluationComplete = 7,
    SendEssentials = 8,
    Rejected = 99
}

export enum enmRepairationStatus {
    Check = 0,
    WaitingForPiece = 1,
    Repairation = 2,
    Done = 3,
    Unrepairable = 4
}

export enum enmFinancialStatus {
    WaitingForPay = 0,
    InPayProgress = 1,
    Paid = 2,
    WaitingForReceipt = 3,
    Receipt = 4
}

export enum enmDocumentCheckStates {
    Reject = 0,
    Complete = 1,
    Defective = 2
}

export enum enmPolicyholderResponseTypes {
    Objection = 0,
    Pay = 1,
    //Repair = 2,
}

export enum enmEvaluationMethods {
    VideoCall = 0,
    //EvaluatorInPerson = 1,
    PolicyholderInPerson = 2,
    PolicyholderInPersonToInsurerBranch = 3
}

export const evaluationMethodsOptions = [
    { disabled: false, name: "برقراری تماس تصویری", makingContactStatusTitle: "منتظر برقراری تماس تصویری", makingContactCommandTitle: "ثبت نتیجه برقراری تماس تصویری", makingContactTitle: "برقراری تماس تصویری", contactSettingStatusTitle: "منتظر تنظیم تماس تصویری", contactSettingCommandTitle: "تنظیم زمان تماس تصویری", value: enmEvaluationMethods.VideoCall },
    //{ disabled : false, name: "مراجعه حضوری ارزیاب به بیمه گزار/مشتری", makingContactStatusTitle: "منتظر مراجعه حضوری ارزیاب به بیمه گزار/مشتری", makingContactCommandTitle: "ثبت نتیجه ارزیابی حضوری", makingContactTitle: "مراجعه حضوری ارزیاب", contactSettingStatusTitle: "منتظر تنظیم زمان مراجعه حضوری ارزیاب به بیمه گزار/مشتری ", contactSettingCommandTitle: "تنظیم زمان مراجعه حضوری ارزیاب به بیمه گزار/مشتری", value: enmEvaluationMethods.EvaluatorInPerson },
    { disabled: false, name: "مراجعه حضوری بیمه گزار/مشتری به مراکز مجاز ارزیابی", makingContactStatusTitle: "منتظر مراجعه حضوری بیمه گزار/مشتری به مرکز ارزیابی", makingContactCommandTitle: "ثبت نتیجه ارزیابی حضوری", makingContactTitle: "مراجعه حضوری بیمه گزار/مشتری", contactSettingStatusTitle: "منتظر تنظیم زمان مراجعه حضوری بیمه گزار/مشتری به مرکز ارزیابی", contactSettingCommandTitle: "تنظیم زمان مراجعه حضوری بیمه گزار/مشتری به مرکز ارزیابی", value: enmEvaluationMethods.PolicyholderInPerson },
    //{ disabled : false, name: "مراجعه حضوری بیمه گزار/مشتری به شعب بیمه سامان", makingContactStatusTitle: "منتظر مراجعه حضوری بیمه گزار/مشتری به شعبه بیمه سامان", makingContactCommandTitle: "مراجعه حضوری بیمه گزار/مشتری به شعبه بیمه سامان", contactSettingStatusTitle: "منتظر تنظیم زمان مراجعه حضوری بیمه گزار/مشتری به شعبه بیمه سامان", contactSettingCommandTitle: "تنظیم زمان مراجعه حضوری بیمه گزار/مشتری به شعبه بیمه سامان", value: enmEvaluationMethods.PolicyholderInPersonToInsurerBranch }
];

export const damageCaseIssuerTypesOptions = [
    { title: 'نرم افزار زبده', value: enmIssuerTypes.Self },
    { title: 'پورتال مشتریان سامان', value: enmIssuerTypes.Cp },
    { title: 'پالیز', value: enmIssuerTypes.Paliz }
];

export const damageCaseStatusOptions = [
    { title: 'ارسال نشده', value: enmDamageCaseStatus.Create },
    { title: 'تخصیص ارزیاب', value: enmDamageCaseStatus.AssignEvaluator },
    { title: 'ارزیابی', value: enmDamageCaseStatus.Evaluation },
    { title: 'تخصیص تعمیرکار', value: enmDamageCaseStatus.AssignRepairCenter },
    { title: 'تعمیر', value: enmDamageCaseStatus.Repairation },
    { title: 'مالی', value: enmDamageCaseStatus.Financial },
    { title: 'خاتمه یافته', value: enmDamageCaseStatus.Closed },
    { title: 'رد شده', value: enmDamageCaseStatus.Rejected },
    { title: 'در انتظار دریافت داغی', value: enmDamageCaseStatus.ReceiveDepreciated },
    { title: 'در انتظار دریافت دستگاه', value: enmDamageCaseStatus.ReceiveEquipment }
];

export const evaluationStatusOptions = [
    { title: 'منتظر بررسی مدارک', name: 'بررسی مدارک', value: enmEvaluationStatus.DocumentCheck },
    { title: 'منتظر  رفع نقص مدارک', name: 'رفع نقص مدارک', value: enmEvaluationStatus.DefectiveDocuments },
    { title: 'منتظر تنظیم تماس', name: 'تنظیم تماس', value: enmEvaluationStatus.ContactSetting },
    { title: 'منتظر برقراری تماس', name: 'برقراری تماس', value: enmEvaluationStatus.MakingContact },
    { title: 'منتظر برآورد خسارت', name: 'برآورد خسارت', value: enmEvaluationStatus.DamageEstimation },
    { title: 'منتظر تاییدیه بیمه گزار/مشتری', name: 'تاییدیه بیمه گزار/مشتری', value: enmEvaluationStatus.PolicyholderConfirmation },
    { title: 'رد شده بیمه گزار/مشتری', name: 'رد شده بیمه گزار/مشتری', value: enmEvaluationStatus.PolicyholderRejected },
    { title: 'تأیید بیمه گزار/مشتری، پایان ارزیابی', name: 'پایان ارزیابی', value: enmEvaluationStatus.EvaluationComplete },
    { title: 'در انتظار دریافت دستگاه و لوازم جانبی', name: 'دریافت دستگاه و لوازم جانبی', value: enmEvaluationStatus.SendEssentials },
    { title: 'رد شده', name: 'رد شده', value: enmEvaluationStatus.Rejected },
];

export const repairationStatusOptions = [
    { title: 'بررسی خسارت', value: enmRepairationStatus.Check },
    { title: 'منتظر قطعه', value: enmRepairationStatus.WaitingForPiece },
    { title: 'درحال تعمیر', value: enmRepairationStatus.Repairation },
    { title: 'پایان تعمیر', value: enmRepairationStatus.Done },
    { title: 'غیرقابل تعمیر', value: enmRepairationStatus.Unrepairable }
];

export interface IDamageCase extends IEntity {
    IssuerType: enmIssuerTypes;
    Code: number;
    TicketNo: number;
    DamageTypeId?: number;
    DamageType?: IDamageType;
    PolicyEquipmentModelId: number;
    PolicyEquipmentModel: IPolicyEquipmentModel;
    EmergencyCallNumber: string;
    DamageDate: any;
    Status: enmDamageCaseStatus;
    ProvinceId?: number;
    Province: IProvince;
    CityId?: number;
    City: ICity;
    Address?: string;
    DamageReasonId?: number;
    DamageReason?: string;
    Description?: string;
    ConfirmPossessionTransition?: boolean;
    EvaluationMethod: enmEvaluationMethods;
    NumberOfPreviousEvaluations: number;
    DamageCaseEvaluators: {
        Id: number;
        Substatus: enmEvaluationStatus;
        EvaluationSteps: { Substatus: enmEvaluationStatus; CreateDateTime: any; }[];
        EvaluatorId: number;
        CreateDateTime: any;
        Evaluator: ICenter;
        Creator?: IUser;
        Estimations: { EstimatedAmaount: number; PayableAmount: number; ExpertConfirmation?: boolean; }[];
        PolicyholderConfirmations: IPolicyholderConfirmation[];
        EvaluationStartTime?: Date | null;
    }[],
    EvaluationStatus?: enmEvaluationStatus;
    DamageCaseRepairCenters: {
        RepairCenterId: number;
        RepairCenter: ICenter;
        Substatus: enmRepairationStatus;
        PayableAmount: number;
    }[]
    RepairationStatus?: enmRepairationStatus;
    PayableAmount?: number;
    PayableAmountString: string;
    DefaultEvaluator?: ICenter;
    DefaultEvaluatorId?: number;
    FinancialStatus?: enmFinancialStatus;
    PossessionTransition?: boolean;
    ReceiveDepreciated?: boolean;
    ReceiveDepreciatedDateTime?: Date;
    SentToBranch?: boolean;
}

export interface IDamageCaseProps extends IEntityManagerProps<IDamageCase> {
    defaultDamageCaseId?: number;
}

export interface IDamageCaseStates extends IEntityManagerStates<IDamageCase> {
    evaluationSteps: any[];
    attachments: any[];
}

export interface IDamageCaseInitialData extends IInitialData {
    Center?: ICenter;
}

export interface IDamageCaseFetchingInfo extends IFetchingInfo {
    EvaluatorId?: number;
    RepairCenterId?: number;
    PolicyholderId?: number;
    LoadNavigations?: boolean;
    EvaluatorFilter?: IFilter;
}
